import { UNAUTHORIZED_STATUS_CODE } from "src/services/tokenRefresh.consts";

const SERVER_ERROR_STATUS_CODE = 500;
const RETRY_LIMITS = {
  [SERVER_ERROR_STATUS_CODE]: 2,
  [UNAUTHORIZED_STATUS_CODE]: 1
};

export const removeInactiveQueries = ({ queryKey, queryClient }) => {
  queryClient
    .getQueryCache()
    .findAll({ queryKey })
    .filter(query => query.isActive() === false)
    .forEach(query => queryClient.removeQueries(query));
};

export const retryIfServerError = (failureCount, error) =>
  failureCount < (RETRY_LIMITS[error?.response?.status] ?? 0);
